var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col-md-4 left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.pos")) +
                " > " +
                _vm._s(_vm.$t("sidebar.poscategory")) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8 right" }, [
          _c(
            "div",
            { staticClass: "action" },
            [
              _c("base-dropdown-filter-download", {
                attrs: { items: _vm.DOWNLOAD_EXTS, loading: false },
                on: { onSelect: _vm.handleSelectDownload }
              }),
              _vm._v(" "),
              _c("base-filter-data-type", {
                attrs: { type: _vm.dataType, items: _vm.REPORT_DATA_TYPES },
                on: { onSelect: _vm.handleSelectDataType }
              }),
              _vm._v(" "),
              _c("base-dropdown-filter-date-range", {
                attrs: {
                  type: _vm.dateType,
                  range: { start: _vm.dateStart, end: _vm.dateEnd },
                  active: _vm.isAppliedFilter
                },
                on: { onSubmit: _vm.handleSubmitFilter }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content col-md-12" }, [
      !_vm.ready
        ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
        : _c(
            "div",
            { staticClass: "col-md-12 no-padding mt-2" },
            [
              _vm.posCategories.length
                ? [
                    _c("section", { staticClass: "mt-2 mb-4" }, [
                      _c(
                        "div",
                        [
                          _c("section-title", {
                            attrs: {
                              title: _vm.datePeriod(_vm.dateStart, _vm.dateEnd),
                              fontweight: "bold"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "keep-alive",
                      [
                        _vm.dataType === _vm.REPORT_DATA_TYPE_VALUE.TABLE
                          ? _c("report-inventory-table", {
                              attrs: {
                                items: _vm.posCategories,
                                columnNames: _vm.columnNames,
                                pickKeys: _vm.pickKeys
                              }
                            })
                          : _c(
                              "div",
                              [
                                _c("div", { staticClass: "row mb-4" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-2 d-flex justify-content-center d-flex align-items-center m-auto",
                                      staticStyle: { "min-width": "267px" }
                                    },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedKey,
                                              expression: "selectedKey"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedKey = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        _vm._l(_vm.keys, function(key, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: { value: key }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.getTextByKey(key)
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.dataType ===
                                _vm.REPORT_DATA_TYPE_VALUE.CHART_BAR
                                  ? _c("report-pos-category-chart", {
                                      attrs: {
                                        items: _vm.posCategories,
                                        selectedKey: _vm.selectedKey,
                                        type: "bar"
                                      }
                                    })
                                  : _vm.dataType ===
                                    _vm.REPORT_DATA_TYPE_VALUE.CHART_LINE
                                  ? _c("report-pos-category-chart", {
                                      attrs: {
                                        items: _vm.posCategories,
                                        selectedKey: _vm.selectedKey,
                                        type: "line"
                                      }
                                    })
                                  : _vm.dataType ===
                                    _vm.REPORT_DATA_TYPE_VALUE.CHART_PIE
                                  ? _c("report-pos-category-chart", {
                                      attrs: {
                                        items: _vm.posCategories,
                                        selectedKey: _vm.selectedKey,
                                        type: "pie"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                      ],
                      1
                    )
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.nodatafound")) +
                        "\n      "
                    )
                  ]
            ],
            2
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20011e32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20011e32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/report/pos/Category.vue
// module id = null
// module chunks = 